import React from 'react'

const SkeletonLine = ({ ...props }) => {
  return (
    <div className='lc-skeleton-line' {...props}>
      <div className='lc-skeleton-line__line'/>
    </div>
  )
}

export default SkeletonLine
